import { cn } from '@/lib/utils';

/**
 * Typography for the pre-rendered legal document fragments. The project does
 * not ship a typography plugin, so the element styles are scoped here with
 * arbitrary variants.
 */
const PROSE_CLASSES = [
    'text-sm leading-relaxed text-foreground',
    '[&_h2]:mt-6 [&_h2]:mb-2 [&_h2]:text-base [&_h2]:font-semibold',
    '[&_h3]:mt-4 [&_h3]:mb-1.5 [&_h3]:text-sm [&_h3]:font-semibold',
    '[&_p]:my-2',
    '[&_ul]:my-2 [&_ul]:list-disc [&_ul]:pl-6 [&_ol]:my-2 [&_ol]:list-decimal [&_ol]:pl-6 [&_li]:my-0.5',
    '[&_a]:text-primary [&_a]:underline [&_a]:underline-offset-2',
    '[&_blockquote]:my-3 [&_blockquote]:border-l-2 [&_blockquote]:border-amber-500/60 [&_blockquote]:bg-amber-500/5 [&_blockquote]:px-3 [&_blockquote]:py-1 [&_blockquote]:text-muted-foreground',
    '[&_table]:my-3 [&_table]:w-full [&_table]:border-collapse [&_table]:text-left',
    '[&_th]:border-b [&_th]:px-2 [&_th]:py-1.5 [&_th]:font-medium',
    '[&_td]:border-b [&_td]:border-border/60 [&_td]:px-2 [&_td]:py-1.5 [&_td]:align-top',
    '[&_hr]:my-4',
    '[&_code]:rounded [&_code]:bg-muted [&_code]:px-1 [&_code]:py-0.5 [&_code]:font-mono [&_code]:text-xs',
].join(' ');

interface LegalProseProps {
    html: string;
    className?: string;
}

/**
 * Renders a pre-rendered legal HTML fragment. The HTML is generated at build
 * time from the PR-reviewed markdown in `legal/` (tools/build-legal-docs.mjs)
 * and served as a same-origin static asset — it is as trusted as the source
 * code itself, never user input.
 */
export function LegalProse({ html, className }: LegalProseProps) {
    return (
        <div
            data-testid="legal-prose"
            className={cn(PROSE_CLASSES, className)}
            dangerouslySetInnerHTML={{ __html: html }}
        />
    );
}
